module.exports = __webpack_public_path__ + "img/Spirituality.3bd458db.svg";